export const specials = [
  {
    id: 'midnight-solitude',
    title: '深夜独处片单',
    englishTitle: 'ALONE AFTER MIDNIGHT',
    tag: '编辑部精选',
    cover: 'https://readdy.ai/api/search-image?query=Empty%20single%20apartment%20at%20night%20lit%20only%20by%20a%20projector%2C%20light%20beam%20crossing%20a%20small%20room%2C%20curtain%20moving%20in%20the%20wind%2C%20warm%20amber%20glow%20against%20deep%20blue%20darkness%2C%20intimate%20cinematic%20mood%2C%20no%20text&width=1200&height=700&seq=midnight-special-01&orientation=landscape',
    description: '适合一个人、关灯、戴耳机的六个夜晚。关于孤独，也关于与自己和解。',
    longDescription: '深夜看电影和白天完全是两件事。白天的电影是消遣，深夜的电影是对话。这个专题里的六部作品都不急着讲故事，它们只是陪着你在黑暗里坐一会儿。建议把手机调成静音，把灯关掉，让屏幕成为房间里唯一的光源。',
    movieIds: ['fathers-film', 'the-last-snow', 'letters-in-the-rain', 'time-mender', 'city-against-current', 'summer-cinema'],
  },
  {
    id: 'time-and-memory',
    title: '时间与记忆的迷宫',
    englishTitle: 'THE LABYRINTH OF TIME',
    tag: '主题策展',
    cover: 'https://readdy.ai/api/search-image?query=Surreal%20corridor%20filled%20with%20hundreds%20of%20floating%20clocks%20and%20fragmented%20photographs%2C%20warm%20amber%20light%20streaks%20through%20deep%20blue%20fog%2C%20dreamlike%20time%20concept%2C%20cinematic%20wide%20composition%2C%20no%20text&width=1200&height=700&seq=midnight-special-02&orientation=landscape',
    description: '如果时间可以被修补、被暂停、被出售，我们还会不会珍惜眼前这一秒？',
    longDescription: '这一类电影共享同一个执念：时间不是线性的，而是一间可以反复进入的房间。有人想修好它，有人想停住它，有人靠贩卖别人的记忆为生。它们用科幻的外壳包裹着最古老的命题——我们如何与无法挽回的事和解。',
    movieIds: ['echoes-of-the-void', 'time-mender', 'neon-labyrinth', 'a-second-of-eternity', 'polar-day'],
  },
  {
    id: 'rainy-noir',
    title: '雨夜黑色电影',
    englishTitle: 'NOIR IN THE RAIN',
    tag: '影迷必看',
    cover: 'https://readdy.ai/api/search-image?query=Rain-soaked%20city%20alley%20at%20night%20with%20reflective%20wet%20asphalt%2C%20neon%20signs%20glowing%20in%20warm%20orange%2C%20a%20single%20silhouette%20under%20a%20streetlamp%2C%20deep%20navy%20shadows%2C%20classic%20film%20noir%20cinematic%20composition%2C%20no%20text&width=1200&height=700&seq=midnight-special-03&orientation=landscape',
    description: '雨、霓虹、枪声和一封没说出口的信。五部把夜晚拍到极致的犯罪片。',
    longDescription: '黑色电影的魅力从不在案件本身，而在于那些被雨水泡软的人。他们做错事，说错话，然后在凌晨的街角遇见一个同样疲惫的陌生人。这份片单里的五部电影，把雨、霓虹和沉默当作同一种语言。',
    movieIds: ['chasing-the-dark', 'neon-labyrinth', 'silent-testimony', 'abyss-express', 'dragon-ridge'],
  },
  {
    id: 'sci-fi-decade',
    title: '华语科幻的十年',
    englishTitle: 'A DECADE OF CHINESE SCI-FI',
    tag: '深度专题',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20city%20skyline%20at%20night%20seen%20through%20a%20giant%20circular%20space%20station%20window%2C%20deep%20blue%20nebula%20sky%20with%20warm%20orange%20city%20lights%2C%20cinematic%20sci-fi%20concept%20art%2C%20no%20text&width=1200&height=700&seq=midnight-special-04&orientation=landscape',
    description: '从仰望星空到回望内心，华语科幻正在走出自己的路。',
    longDescription: '十年前，讨论华语科幻几乎等同于讨论特效水平。十年后，最好的几部作品已经不再依赖奇观，而是用科幻设定去追问一些非常具体的问题：记忆属于谁，孤独能否被传输，人为什么需要一个可以回去的地方。',
    movieIds: ['echoes-of-the-void', 'neon-labyrinth', 'polar-day', 'wasteland-courier', 'time-mender'],
  },
  {
    id: 'growing-up-summer',
    title: '盛夏成长手册',
    englishTitle: 'THE SUMMER WE GREW UP',
    tag: '季节限定',
    cover: 'https://readdy.ai/api/search-image?query=Nostalgic%20small-town%20cinema%20and%20bicycle%20road%20in%20late%20summer%20afternoon%2C%20long%20shadows%2C%20dust%20in%20golden%20sunlight%2C%20faded%20teal%20and%20amber%20film%20tones%2C%20nostalgic%20cinematic%20still%2C%20no%20text&width=1200&height=700&seq=midnight-special-05&orientation=landscape',
    description: '关于第一次心动、第一次告别、以及那个再也回不去的暑假。',
    longDescription: '夏天的电影总是亮得刺眼，因为它记录的是我们最后一次无所事事的时光。这几部作品里有旧影院、有海边公路、有一封没有寄出的信，也有那些当时觉得天大的、后来才发现很小的事。',
    movieIds: ['summer-cinema', 'between-mountains-and-sea', 'letters-in-the-rain', 'the-last-snow', 'fathers-film'],
  },
  {
    id: 'action-no-double',
    title: '真打实拍动作档案',
    englishTitle: 'ACTION WITHOUT DOUBLES',
    tag: '硬核片单',
    cover: 'https://readdy.ai/api/search-image?query=Silhouettes%20of%20two%20martial%20artists%20facing%20each%20other%20on%20a%20misty%20mountain%20ridge%20at%20dawn%2C%20dramatic%20warm%20rim%20light%20against%20deep%20blue%20clouds%2C%20dust%20and%20mist%2C%20epic%20cinematic%20action%20composition%2C%20no%20text&width=1200&height=700&seq=midnight-special-06&orientation=landscape',
    description: '没有绿幕，没有替身。四部把身体当成特效的电影。',
    longDescription: '当特效可以做到任何事，仍然有人愿意花四十七天拍三个镜头。这份片单收录了近年最“疼”的几部动作片——它们的共同点是不相信捷径，相信肌肉、呼吸和重力。',
    movieIds: ['dragon-ridge', 'chasing-the-dark', 'wasteland-courier', 'laughing-changan'],
  },
];